import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.uploadConfirmation.title',
    defaultMessage: 'ANSWER CARD UPLOAD',
  },
  singularSubtitle: {
    id: 'simulated.uploadConfirmation.singularSubtitle',
    defaultMessage: 'Answer card successfully processed.',
  },
  pluralSubtitle: {
    id: 'simulated.uploadConfirmation.pluralSubtitle',
    defaultMessage: 'Answer cards processed successfully.',
  },
  close: {
    id: 'simulated.uploadConfirmation.close',
    defaultMessage: 'Close',
  },
  errorAlreadyExists: {
    id: 'simulated.uploadConfirmation.errorAlreadyExists',
    defaultMessage: 'There is already a correction for this student.',
  },
  errorAnswersheetNotMatchEvaluation: {
    id: 'simulated.uploadConfirmation.errorAnswersheetNotMatchEvaluation',
    defaultMessage: 'AnswerSheet dont match with evaluation.',
  },
  errorStudentNotFound: {
    id: 'simulated.uploadConfirmation.errorStudentNotFound',
    defaultMessage: 'Student not found',
  },
  errorPermissionDenied: {
    id: 'simulated.uploadConfirmation.errorPermissionDenied',
    defaultMessage: 'This user is not allowed to upload answer cards for this school.',
  },
  errorScan: {
    id: 'simulated.uploadConfirmation.errorScan',
    defaultMessage: 'Error reading, please contact the administrator.',
  },
  errorFileNotSupported: {
    id: 'simulated.uploadConfirmation.errorFileNotSupported',
    defaultMessage: 'Unsupported file type. Only .jpg and .png files can be loaded.',
  },
  successMessage: {
    id: 'simulated.uploadConfirmation.successMessage',
    defaultMessage: 'Successfully loaded.',
  },
  defaultFriendlyErrorMessage: {
    id: 'simulated.uploadConfirmation.defaultFriendlyErrorMessage',
    defaultMessage:
      'Error reading card, please review the quality, resolution, erasures, rotation, etc., which may interfere with reading.',
  },
  alreadyCorrected: {
    id: 'simulated.uploadConfirmation.alreadyCorrected',
    defaultMessage: 'There is already a correction for this student',
  },
  SM001: {
    id: 'simulated.uploadConfirmation.SM001',
    defaultMessage: 'Image file must be informed',
  },
  SM0002: {
    id: 'simulated.uploadConfirmation.SM0002',
    defaultMessage: 'File does not exist',
  },
  SM0003: {
    id: 'simulated.uploadConfirmation.SM0003',
    defaultMessage: 'Invalid contours detection',
  },
  SM0004: {
    id: 'simulated.uploadConfirmation.SM0004',
    defaultMessage: 'No bubbles detected',
  },
  SM0005: {
    id: 'simulated.uploadConfirmation.SM0005',
    defaultMessage: 'Alternatives amount do not match with number informed',
  },
  SM0006: {
    id: 'simulated.uploadConfirmation.SM0006',
    defaultMessage: 'Questions amount do not match with number informed',
  },
  SM0007: {
    id: 'simulated.uploadConfirmation.SM0007',
    defaultMessage: 'Invalid question delimiters contours detection',
  },
  SM0008: {
    id: 'simulated.uploadConfirmation.SM0008',
    defaultMessage: 'Invalid amount of bubbles detected per column',
  },
  SM0009: {
    id: 'simulated.uploadConfirmation.SM0009',
    defaultMessage: 'Invalid external delimiters contours detection',
  },
  SM0010: {
    id: 'simulated.uploadConfirmation.SM0010',
    defaultMessage: 'Invalid external exam delimiters detected',
  },
  SM0011: {
    id: 'simulated.uploadConfirmation.SM0011',
    defaultMessage: 'Invalid or malformed QR code image',
  },
  SM0018: {
    id: 'simulated.uploadConfirmation.SM0018',
    defaultMessage: 'There are multiple entries in the same column for the student\'s RA.',
  },
  errorGeneric: {
    id: 'simulated.uploadConfirmation.errorGeneric',
    defaultMessage: 'Error uploading answer card',
  },
});
